import MedicineDictionaryModel from '@/entities/medicine-dictionary/model/medicineDictionary.model';
import { createMedicineDictionaryDetailUrl } from '@/entities/medicine-dictionary/util';
import usePopularMedicineDictionaryItems from '@/hooks/medicine-dictionary/usePopularMedicineDictionaryItems';
import useCustomRouter from '@/hooks/useCustomRouter';

interface SearchPopularMedicineDictionaryViewModel {
  popularMedicineDictionaryItems: Array<MedicineDictionaryModel>;
  onClickMedicineDictionary: (medicineDictionary: MedicineDictionaryModel) => () => void;
}

const useSearchPopularMedicineDictionaryViewModel = (): SearchPopularMedicineDictionaryViewModel => {
  const { router } = useCustomRouter();
  const { popularMedicineDictionaryItems } = usePopularMedicineDictionaryItems();

  const items = popularMedicineDictionaryItems?.slice(0, 6) || [];

  const onClickMedicineDictionary = (medicineDictionary: MedicineDictionaryModel) => () => {
    router.push(createMedicineDictionaryDetailUrl(medicineDictionary));
  };

  return {
    popularMedicineDictionaryItems: items,
    onClickMedicineDictionary,
  };
};

export default useSearchPopularMedicineDictionaryViewModel;
